module.exports = __webpack_public_path__ + "assets/img/detail2.f1e929b8.png";